import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoAlertSiiComponent } from './info-alert-sii.component';

@NgModule({
  declarations: [
    InfoAlertSiiComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    InfoAlertSiiComponent,
  ]
})
export class InfoAlertSiiModule { }
